import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { stopPropagation } from '@prophecy/utils/dom';
import React, { useState, forwardRef } from 'react';
import { ButtonVariants } from '../Button/types';
import { Stack } from '../Layout';
import { StyledButton, StyledClearIcon, StyledNumberContainer, StyledIconWrapper } from './styled';
import { tokens } from './tokens';
import { Size, Placement } from './types';
function _Tags({ closable = false, onClose, icon, children, size = Size.m, count, iconPlacement = Placement.left, prefix, disabled, countCircle = false, ...restProps }, forwardRef) {
    const [visible, toggle] = useState(true);
    if (!visible) {
        return null;
    }
    const _onClose = (e)=>{
        toggle(false);
        onClose?.();
    };
    const closeIcon = closable ? /*#__PURE__*/ _jsx(StyledClearIcon, {
        type: "default",
        size: size,
        onClick: !disabled ? _onClose : undefined,
        onPointerDown: stopPropagation,
        "data-test-id": "tag-close-icon"
    }) : null;
    return /*#__PURE__*/ _jsx(StyledButton, {
        ref: forwardRef,
        variant: ButtonVariants.secondaryGray,
        size: size,
        $closable: closable,
        $isIcon: !!icon,
        disablePointerFocus: true,
        disabled: disabled,
        ...restProps,
        iconPlacement: iconPlacement,
        "data-test-id": restProps['data-test-id'] || 'tags',
        children: /*#__PURE__*/ _jsxs(Stack, {
            direction: "horizontal",
            alignY: "center",
            gap: tokens.TagsRoot.size[size].gap,
            children: [
                iconPlacement === Placement.left && closeIcon,
                iconPlacement === Placement.left && icon && /*#__PURE__*/ _jsx(StyledIconWrapper, {
                    $size: size,
                    $disabled: disabled,
                    $iconPlacement: iconPlacement,
                    children: icon
                }),
                prefix,
                children,
                count !== undefined && /*#__PURE__*/ _jsx(StyledNumberContainer, {
                    disabled: disabled,
                    countCircle: countCircle,
                    size: size,
                    children: count
                }),
                iconPlacement === Placement.right && icon && /*#__PURE__*/ _jsx(StyledIconWrapper, {
                    $size: size,
                    $disabled: disabled,
                    $iconPlacement: iconPlacement,
                    children: icon
                }),
                iconPlacement === Placement.right && closeIcon
            ]
        })
    });
}
// NOTE: Sadly forwardRef doesn't allow generic types, so we have to typecast it
export const Tags = /*#__PURE__*/ forwardRef(_Tags);
